import Vue from 'vue'
import Vuex from 'vuex'
import videoCall from './modules/videoCall'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    videoCall
  },
  state: {
    token: '',
    account: '',
    yxToken: '',
    userInfo: {},
  },
  mutations: {
    setToken(state, token) {
      state.token = token
    },
    setUserInfo(state, userInfo) {
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
      state.userInfo = userInfo
    },
    SET_LOGIN_USER(state, payload) {
      const { token, userInfo } = payload
      state.token = token
      state.userInfo = userInfo

      localStorage.setItem('token', token)
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    SET_YX_ACCOUNT_TOKEN(state, obj) {
      state.account = obj.account
      state.yxToken = obj.yxToken
      localStorage.setItem('yxToken', obj.yxToken)
      localStorage.setItem('account', obj.account)
    },
    LOGOUT(state) {
      state.token = ''
      state.account = ''
      state.yxToken = ''
      state.userInfo = {}
      localStorage.clear()
    },
  },
  actions: {
    restoreLogin({ commit }) {
      const token = localStorage.getItem('token')
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || 'null')

      const account = localStorage.getItem('account')
      const yxToken = localStorage.getItem('yxToken')

      if (token && yxToken && userInfo) {
        commit('setToken', token)
        commit('setUserInfo', userInfo)
        commit('SET_YX_ACCOUNT_TOKEN', { account, yxToken })
        return true
      }
      return false
    },
  },
  getters: {
    isLogin: state => !!state.token,
    userInfo: state => state.userInfo,
    yxToken: state => state.yxToken,
    account: state => state.account,
    loginInfo: state => ({
      token: state.token,
      yxToken: state.yxToken,
      userInfo: state.userInfo,
    }),
  },
})
